/*
 * @Description: 其它方法
 */

// ---------------------------------------------------------------------------

/**
 * 定时器
 */
let t = null;

/**
 * 防抖 
 * @param {*} fn 回调
 * @param {*} delay 延迟
 */
function debounce(fn, delay = 500) {
	if (t !== null) {
		clearTimeout(t);
	}
	t = setTimeout(() => {
		fn()
	}, delay)
}

/**
 * 节流
 * @param {*} fn 回调
 * @param {*} delay 延迟
 */
function throttle(fn, delay = 500) {
	let last = 0;
	return function() {
		let context = this;
		let args = arguments;
		let now = +new Date();
		if (now - last < delay) return;
		last = now;
		fn.apply(context, args)
	}
}

// ---------------------------------------------------------------------------

/** 
 * 过滤emoji表情
 * @param {*} content
 */
function replaceEmoji(content) {
	/* let newName = '';
	const is4Byte = (str) => {
		return str.codePointAt(0) > 65535;
	};
	for (let item of content) {
		if (!is4Byte(item)) {
			newName += item;
		}
	}
	return newName.replace(/ud83c[udf00-udfff]|ud83d[udc00-ude4f]|ud83d[ude80-udeff]/g, ''); */
	// 使用正则表达式直接匹配并移除Emoji字符
	return content.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu, '');
}

// ---------------------------------------------------------------------------

/** 
 * 按照某个字段对对象数组进行去重
 * @param {*} data 数据列表
 * @param {*} key 去重字段
 */
function uniqObject(data, key) {
	/* let result = [],
		hash = {};
	for (let i = 0, elem; data.length > i && (elem = data[i]) != null; i++) {
		if (!hash[elem[key]]) {
			result.push(elem);
			hash[elem[key]] = true;
		}
	}
	return result; */

	const hash = {};
	const result = [];

	// 从后向前遍历，确保保留新值
	for (let i = data.length - 1; i >= 0; i--) {
		const elem = data[i];
		if (!hash[elem[key]]) {
			hash[elem[key]] = true;
			result.unshift(elem); // 使用 unshift 保证顺序正确
		}
	}

	return result;
}


// ---------------------------------------------------------------------------

/**
 * console.log格式化输出，避免出现 value: (...) 的情况
 * @param {...any} args 任意数量的参数数组
 */
function consoleLog(...args) {
	args.forEach(msg => {
		if (typeof msg === "object") {
			console.log(JSON.stringify(msg, null, 4));
		} else {
			console.log(msg);
		}
	});
}

// ---------------------------------------------------------------------------

/**
 * 将所有方法挂载到tool上，由App.vue统一调用
 * 使用getApp().xxx()的方式可以全局调用
 */

import message from './message.js';
import request from './request.js';
import date from './date.js';
import compress from './compress.js';
import upload from './upload.js';
import file from './file.js';
import download from './download.js';
import judge from './judge.js';
import { setLanguage } from '@/common/i18n';

export default {
	value: {
		...message.value,
		...request.value,
		...date.value,
		...compress.value,
		...upload.value,
		...file.value,
		...download.value,
		...judge.value,
	},
	method: {
		...message.method,
		...request.method,
		...date.method,
		...compress.method,
		...upload.method,
		...file.method,
		...download.method,
		...judge.method,

		throttle,
		debounce,
		replaceEmoji,
		uniqObject,
		consoleLog,

		setLanguage,
	}
};